import Login from "./screens/Login";

const rootPath = 'auth'
export const authRoutes = [
    {
        path: rootPath + '/login',
        element: <Login />,
        isProtected: false
    },]